module.exports = __webpack_public_path__ + "static/media/3rd_banner_item1.dca450a4.png";